export default __webpack_public_path__ + "static/media/onelastpush.fc4c0009.png";